import { RootState } from "../../store";

export const selectAdvert = (state: RootState) => state.advert;